import { Species, SpeciesSurveyDataV1 } from '@omniafishing/core';
import React from 'react';
import { SpeciesDetail } from './species_detail';
import { SpeciesList } from './species_list';

interface TabSpeciesProps {
  waterbodySpeciesSurveyData: SpeciesSurveyDataV1;
  topSpecies: Species;
  selectedSpecies: Species | null;
  onSpeciesSelect: (species: Species | null) => void;
}

export const TabSpecies = (props: TabSpeciesProps) => {
  const { waterbodySpeciesSurveyData, topSpecies, onSpeciesSelect, selectedSpecies } = props;

  if (selectedSpecies) {
    return (
      <SpeciesDetail
        species={selectedSpecies}
        onBackClick={() => {
          onSpeciesSelect(null);
        }}
        speciesData={waterbodySpeciesSurveyData.species[selectedSpecies.display_name]}
        key={selectedSpecies.name}
      />
    );
  }

  return (
    <SpeciesList
      waterbodySpeciesSurveyData={waterbodySpeciesSurveyData}
      topSpecies={topSpecies}
      onSpeciesSelect={onSpeciesSelect}
    />
  );
};
